(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('TransactionRevenueCtrl', TransactionRevenueCtrl);

  // @ngInject
  function TransactionRevenueCtrl(storeKeys, filters, DateUtil, ConsumerChart, TransactionReports, StandardReports, Callout,
                                  SectionConfig, CalloutLabelService) {
    var vm = this;

    var detailLevel = filters.pathParams.detailLevel;

    vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};

    vm.transactionColorSwatch = StandardReports.getColorSwatches();

    var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});
    vm.apiParams = { detailLevel: detailLevel, queryParams: queryFilters };

    vm.revenueSection = Callout.labelValueConfig(SectionConfig.revenue);
    vm.revenueChartData = function(rawData) {
      var formattedRawData = StandardReports.transformIntoChartData('revenue')(rawData);
      return {
        dateMetrics: formattedRawData.dateMetrics,
        summary: rawData.summary
      };
    };

    vm.aovSection = Callout.metricChangeConfig(SectionConfig.aov);
    vm.aovChartData = function(rawData) {
      var formattedRawData = StandardReports.transformIntoChartData('aov')(rawData);
      return {
        dateMetrics: formattedRawData.dateMetrics,
        summary: rawData.summary
      };
    };

    vm.rpsSection = Callout.metricChangeConfig(SectionConfig.rps);
    vm.rpsChartData = function(rawData) {
      return rawData;
    };

    vm.arpuSection = Callout.metricChangeConfig(SectionConfig.arpu);
    vm.arpuChartData = function(rawData) {
      return rawData;
    };

    vm.mrpsSection = Callout.metricChangeConfig(SectionConfig.mrps);
    vm.mrpsChartData = function(rawData) {
      return rawData;
    };

    vm.uptSection = Callout.metricChangeConfig(SectionConfig.upt);
    vm.uptChartData = function(rawData) {
      var formattedRawData = StandardReports.transformIntoChartData('upt')(rawData);
      return {
        dateMetrics: formattedRawData.dateMetrics,
        summary: rawData.summary
      };
    };

    vm.unitsSection = Callout.labelValueConfig(SectionConfig.units);
    vm.unitsChartData = function(rawData) {
      var formattedRawData = StandardReports.transformIntoChartData('units')(rawData);
      return {
        dateMetrics: formattedRawData.dateMetrics,
        summary: rawData.summary
      };
    };

  }
  })();
